// Fallback only — prefer DB cities via /shipping/cities (Leopards import).
export const pakistanCities = [
  "Abbottabad", "Ahmadpur East", "Arifwala", "Attock",
  "Bahawalnagar", "Bahawalpur", "Bannu", "Bhakkar", "Burewala",
  "Chakwal", "Charsadda", "Chichawatni", "Chiniot", "Chishtian", "Chitral",
  "Dadu", "Daska", "Depalpur", "Dera Ghazi Khan", "Dera Ismail Khan",
  "Faisalabad", "Fateh Jang", "Ferozwala", "Fort Abbas",
  "Gilgit", "Gojra", "Gujar Khan", "Gujranwala", "Gujrat", "Gwadar",
  "Hafizabad", "Haripur", "Hasan Abdal", "Hasilpur", "Hub", "Hujra Shah Muqeem", "Hyderabad",
  "Islamabad",
  "Jacobabad", "Jalalpur", "Jand", "Jaranwala", "Jhang", "Jhelum", "Jauharabad",
  "Kahuta", "Kamalia", "Kamoke", "Karachi", "Kasur", "Khanewal", "Khanpur",
  "Khairpur", "Khushab", "Khuzdar", "Kohat", "Kot Abdul Malik", "Kotri",
  "Lahore", "Lakki Marwat", "Larkana", "Layyah", "Liaquatpur", "Lodhran",
  "Mandi Bahauddin", "Mansehra", "Mardan", "Mianwali", "Mingora", "Mirpur", "Mirpur Khas",
  "Multan", "Muridke", "Murree", "Muzaffarabad", "Muzaffargarh",
  "Nankana Sahib", "Narowal", "Nawabshah", "Nowshera",
  "Okara",
  "Pakpattan", "Pasrur", "Pattoki", "Peshawar", "Pindi Gheb", "Pir Mahal",
  "Quetta",
  "Rahim Yar Khan", "Rajanpur", "Rawalpindi", "Renala Khurd",
  "Sadiqabad", "Sahiwal", "Samundri", "Sargodha", "Shakargarh", "Sheikhupura",
  "Shikarpur", "Sialkot", "Skardu", "Sukkur", "Swat",
  "Talagang", "Tando Adam", "Tando Allahyar", "Taxila", "Toba Tek Singh", "Turbat",
  "Umerkot",
  "Vehari",
  "Wah Cantonment", "Wazirabad"
].sort();
